export default "__VITE_ASSET__BlUDWlIk__"